module.exports = __webpack_public_path__ + "static/media/learning-2.d69be021.png";